import { create } from 'zustand';
import { defaultInquiryFilters } from '@/features/businessInquiries/lib/businessInquiryLabels';
import type { BusinessInquiryFilters } from '@/features/businessInquiries/types/businessInquiry';

/**
 * QA-628 비즈니스 문의 목록 조회 조건 — 상세에서 [목록]으로 돌아와도 검색 조건·페이지가 그대로다.
 * [검색]을 눌러야 조회 조건이 바뀐다(입력 중인 값은 검색 영역이 따로 들고 있다).
 */
interface BusinessInquiryFiltersState {
  filters: BusinessInquiryFilters;
  page: number;
  size: number;
  applyFilters: (filters: BusinessInquiryFilters) => void;
  setPage: (page: number) => void;
  setSize: (size: number) => void;
  reset: () => void;
}

export const useBusinessInquiryFiltersStore = create<BusinessInquiryFiltersState>()((set) => ({
  filters: defaultInquiryFilters(),
  page: 1,
  size: 20,
  applyFilters: (filters) => set({ filters, page: 1 }),
  setPage: (page) => set({ page }),
  setSize: (size) => set({ size, page: 1 }),
  reset: () => set({ filters: defaultInquiryFilters(), page: 1 }),
}));
